module.exports = __webpack_public_path__ + "static/media/ProjectsInactive1.cdd45b26.png";